import { HttpError } from 'react-admin';
import { API_BASE_URL, setAuthTokens } from '../apiClient.ts';

export type CheckoutStatus =
  | { status: 'pending' }
  | { status: 'ready'; companyName: string; email: string }
  | { status: 'set-password'; companyName: string; email: string; token: string };

// Both calls are public: a buyer has no session until they set a password.

export const fetchCheckoutStatus = async (
  sessionId: string,
  signal?: AbortSignal
): Promise<CheckoutStatus> => {
  const response = await fetch(`${API_BASE_URL}/signup/checkout/${encodeURIComponent(sessionId)}`, {
    signal
  });
  if (!response.ok) {
    throw new HttpError('This checkout could not be found', response.status);
  }
  return (await response.json()) as CheckoutStatus;
};

/** Sets the password from a link and keeps the session the API returns, so the buyer lands signed in. */
export const setPasswordWithLink = async (token: string, password: string) => {
  const response = await fetch(`${API_BASE_URL}/auth/set-password`, {
    method: 'POST',
    headers: new Headers({ 'Content-Type': 'application/json' }),
    body: JSON.stringify({ token, password })
  });
  const data = (await response.json().catch(() => ({}))) as {
    access_token?: string;
    refresh_token?: string;
    message?: string | string[];
  };
  if (!response.ok || !data.access_token || !data.refresh_token) {
    const message = Array.isArray(data.message) ? data.message.join(' ') : data.message;
    throw new HttpError(message || 'Your password could not be set', response.status);
  }
  setAuthTokens(data.access_token, data.refresh_token);
};
